import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { UNHMembershipPrincingTranslation } from '@frontend/unhideschool/app/utils/i18n/locale/unh-membership-pricing/unh-membership-pricing.i18n.model';
import { UseTranslations } from '@frontend/unhideschool/app/utils/i18n/use-translation.decorator';

interface Translations {
  "unh-membership-pricing": UNHMembershipPrincingTranslation;
}


@Component({
  selector: 'unh-compare-grid',
  templateUrl: './compare-grid.component.html',
  styleUrls: ['./compare-grid.component.scss']
})

@UseTranslations({
  translatableComponents : ["unh-membership-pricing"]
})

export class CompareGridComponent {
  @Input() ispro: boolean;
  @Input() islogged: boolean;
  @Output() actionClicked = new EventEmitter();

  membershipPricingMock : UNHMembershipPrincingTranslation;
  

  translations: Promise<Translations>;

  ngOnInit(): void {
    this.translations.then((translations) => {
      this.membershipPricingMock = translations['unh-membership-pricing'];
    })
  }
  /** 
  features = [
    {
      feature: 'Acesso às aulas Free',
      access: [
        {
          name: 'community',
          available: true
        },
        {
          name: 'individual',
          available: true
        },
        {
          name: 'team',
          available: true
        }
      ]
    },
    {
      feature: 'Participação em Contests',
      access: [
        {
          name: 'community',
          available: true
        },
        {
          name: 'individual',
          available: true
        },
        {
          name: 'team',
          available: true
        },
      ]
    },
    {
      feature: 'Acesso aos recursos e conteúdos do Fórum',
      access: [
        {
          name: 'community',
          available: true
        },
        {
          name: 'individual',
          available: true
        },
        {
          name: 'team',
          available: true
        },
      ]
    },
    {
      feature: 'UNHIDE Gallery',
      access: [
        {
          name: 'community',
          available: true
        },
        {
          name: 'individual',
          available: true
        },
        {
          name: 'team',
          available: true
        },
      ]
    },
    {
      feature: 'Acesso a todos os cursos disponíveis',
      access: [
        {
          name: 'community',
          available: false
        },
        {
          name: 'individual',
          available: true
        },
        {
          name: 'team',
          available: true
        },
      ]
    },
    {
      feature: 'Acesso ao Media Pool dos cursos',
      access: [
        {
          name: 'community',
          available: false
        },
        {
          name: 'individual',
          available: true
        },
        {
          name: 'team',
          available: true
        },
      ]
    },
    {
      feature: 'Certificado por curso concluído',
      access: [
        {
          name: 'community',
          available: false
        },
        {
          name: 'individual',
          available: true
        },
        {
          name: 'team',
          available: true
        },
      ]
    },
    {
      feature: 'Mentoria especializada',
      access: [
        {
          name: 'community',
          available: false
        },
        {
          name: 'individual',
          available: true
        },
        {
          name: 'team',
          available: true
        },
      ]
    },
    {
      feature: 'Gerenciador de time',
      access: [
        {
          name: 'community',
          available: false
        },
        {
          name: 'individual',
          available: false
        },
        {
          name: 'team',
          available: true
        },
      ]
    },
    {
      feature: 'Gestão flexível de usuários',
      access: [
        {
          name: 'community',
          available: false
        },
        {
          name: 'individual',
          available: false
        },
        {
          name: 'team',
          available: true
        },
      ]
    },
    {
      feature: 'Desconto a cada 5 artistas no plano',
      access: [
        {
          name: 'community',
          available: false
        },
        {
          name: 'individual',
          available: false
        },
        {
          name: 'team',
          available: true
        },
      ]
    },
    {
      feature: 'Experiência customizada por usuário',
      access: [
        {
          name: 'community',
          available: false
        },
        {
          name: 'individual',
          available: false
        },
        {
          name: 'team',
          available: true
        },
      ]
    },
  ];
  */
}
